import React from "react";
import camelCase from "lodash/camelCase";
import cloneDeep from "lodash/cloneDeep";
import moment from "moment";
import styled, { css } from "styled-components";
import i18n from "i18n";
import { ControlLabel, FormControl, FormGroup, InputGroup } from "components/bootstrap";
import { TimeUnitInput } from "components/common";
import { extractDurationAndUnit } from "components/common/TimeUnitInput";
import * as FormsUtils from "util/FormsUtils";
const TIME_UNITS = ["HOURS", "MINUTES", "SECONDS"];
const t = (key) => i18n.t(key, { ns: "event_definitions" });
const Container = styled.div(
  ({ theme }) => css`
    padding-top: ${theme.spacings.lg};
  `
);
class NotificationSettingsForm extends React.Component {
  constructor(props) {
    super(props);
    this.propagateChanges = (key, value) => {
      const { eventDefinition, onSettingsChange } = this.props;
      const nextNotificationSettings = cloneDeep(eventDefinition.notification_settings);
      nextNotificationSettings[key] = value;
      onSettingsChange("notification_settings", nextNotificationSettings);
    };
    this.handleGracePeriodChange = (nextValue, nextUnit, enabled) => {
      const durationInMs = enabled ? moment.duration(Math.max(nextValue, 0), nextUnit).asMilliseconds() : 0;
      this.propagateChanges("grace_period_ms", durationInMs);
      this.setState({ gracePeriodDuration: nextValue, gracePeriodUnit: nextUnit });
    };
    this.handleBacklogSizeChange = (event) => {
      const { name } = event.target;
      const value = event.target.value === "" ? "" : FormsUtils.getValueFromInput(event.target);
      this.setState({ [camelCase(name)]: value });
      this.propagateChanges(name, Math.max(Number(value), 0));
    };
    this.toggleBacklogSize = () => {
      const { isBacklogSizeEnabled, backlogSize } = this.state;
      this.setState({ isBacklogSizeEnabled: !isBacklogSizeEnabled });
      this.propagateChanges("backlog_size", isBacklogSizeEnabled ? 0 : backlogSize);
    };
    const { backlog_size: backlogSize, grace_period_ms: gracePeriodMs } = props.eventDefinition.notification_settings;
    const gracePeriod = extractDurationAndUnit(gracePeriodMs, TIME_UNITS);
    const defaultBacklogSize = props.defaults.default_backlog_size;
    const effectiveBacklogSize = backlogSize != null ? backlogSize : defaultBacklogSize;
    this.state = {
      gracePeriodDuration: gracePeriod.duration,
      gracePeriodUnit: gracePeriod.unit,
      isBacklogSizeEnabled: backlogSize === null ? false : effectiveBacklogSize > 0,
      backlogSize: effectiveBacklogSize
    };
  }
  render() {
    const { eventDefinition } = this.props;
    const { gracePeriodDuration, gracePeriodUnit, isBacklogSizeEnabled, backlogSize } = this.state;
    if (eventDefinition.notifications.length === 0) {
      return null;
    }
    return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(FormGroup, { controlId: "grace-period" }, /* @__PURE__ */ React.createElement(
      TimeUnitInput,
      {
        label: t("notification_settings.grace_period"),
        update: this.handleGracePeriodChange,
        defaultEnabled: gracePeriodDuration !== 0,
        value: gracePeriodDuration,
        unit: gracePeriodUnit,
        units: TIME_UNITS,
        clearable: true
      }
    ), /* @__PURE__ */ React.createElement("p", null, t("notification_settings.grace_period_help"))), /* @__PURE__ */ React.createElement(FormGroup, null, /* @__PURE__ */ React.createElement(ControlLabel, null, t("notification_settings.message_backlog")), /* @__PURE__ */ React.createElement(InputGroup, null, /* @__PURE__ */ React.createElement(InputGroup.Addon, null, /* @__PURE__ */ React.createElement(
      "input",
      {
        id: "toggle_backlog_size",
        type: "checkbox",
        "aria-label": t("notification_settings.toggle_message_backlog"),
        checked: isBacklogSizeEnabled,
        onChange: this.toggleBacklogSize
      }
    )), /* @__PURE__ */ React.createElement(
      FormControl,
      {
        type: "number",
        id: "backlog_size",
        name: "backlog_size",
        onChange: this.handleBacklogSizeChange,
        value: backlogSize,
        disabled: !isBacklogSizeEnabled
      }
    )), /* @__PURE__ */ React.createElement("p", null, t("notification_settings.message_backlog_help"))));
  }
}
export default NotificationSettingsForm;
